var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsmobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-label": "Desarrollo de aplicaciones mobile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3a86d8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 170,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#3a86d8",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    fill: "none",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 40 Q 80 30 110 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 40 Q 170 30 140 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 170 Q 75 178 110 158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 160 Q 170 152 142 150"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36,70)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 84,
    rx: 8,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 40,
    height: 62,
    rx: 3,
    fill: "#bfe0f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 40,
    height: 10,
    fill: "#42a5e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24,
    width: 32,
    height: 4,
    rx: 1.5,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 32,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#3a86d8",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 40,
    width: 32,
    height: 4,
    rx: 1.5,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 48,
    width: 18,
    height: 3,
    rx: 1.5,
    fill: "#3a86d8",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 56,
    width: 28,
    height: 4,
    rx: 1.5,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 76,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#bfe0f5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(92,30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 140,
    rx: 12,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 68,
    height: 112,
    rx: 4,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 6,
    width: 12,
    height: 3,
    rx: 1.5,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 131,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#bfe0f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 68,
    height: 10,
    fill: "#42a5e0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 19,
    r: 1.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 17.5,
    width: 8,
    height: 3,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 56,
    height: 22,
    rx: 4,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 36,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 42,
    width: 34,
    height: 2.5,
    rx: 1.5,
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 46.5,
    width: 28,
    height: 2.5,
    rx: 1.5,
    fill: "#fff",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 58,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#3a86d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 58,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#42a5e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 58,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#bfe0f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 78,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#42a5e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 78,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#bfe0f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 78,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#3a86d8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 100,
    width: 64,
    height: 22,
    rx: 4,
    fill: "#bfe0f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 103,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 113 L16 108.5 L21 113 L21 117 L18 117 L18 114.5 L14 114.5 L14 117 L11 117 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2e5bba",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 110,
    r: 2.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 112,
    x2: 40.5,
    y2: 113.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2e5bba"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 109,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 116 C 52.5 113.5 61.5 113.5 61.5 116 L 61.5 117.5 L 52.5 117.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2e5bba",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 119,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#ffffff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 119,
    width: 8,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 119,
    width: 8,
    height: 1,
    rx: 0.5
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,52)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 16,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7 C -2 4 -8 1 -8 -4 C -8 -7 -5 -8 -3 -7 C -1 -6 0 -4 0 -2 C 0 -4 1 -6 3 -7 C 5 -8 8 -7 8 -4 C 8 1 2 4 0 7 Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58,46)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 14,
    fill: "#42a5e0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7 -2 H7 a3 3 0 0 1 3 3 v3 a3 3 0 0 1 -3 3 H-2 l-5 4 v-4 H-7 a3 3 0 0 1 -3 -3 v-3 a3 3 0 0 1 3 -3 Z",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,128)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 15,
    fill: "#3a86d8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "-5,-5 -9,0 -5,5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5,-5 9,0 5,5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -6,
    x2: -2,
    y2: 6
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75,171)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 12,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -1,
    width: 2.6,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -4,
    width: 2.6,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: -2.5,
    width: 2.6,
    height: 6.5,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsmobile);
export default __webpack_public_path__ + "static/media/appsmobile.553d8e2b31e93f716adc71013c3bab73.svg";
export { ForwardRef as ReactComponent };